const React = require("react");

const Content = ({ children }) => <div className="content">{children}</div>;

Content.displayName = "Content";

export default Content;
